import * as tokens from '../../../tokens/typography.generated.js';
export const systemTypography = {
    typography: {
        display: {
            order: {
                1: {
                    normal: {
                        bp: {
                            xs: tokens.SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_XS,
                            sm: tokens.SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_SM,
                            md: tokens.SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_MD,
                            lg: tokens.SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_LG,
                            xl: tokens.SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_XL,
                            xxl: tokens.SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP2_XL
                        }
                    },
                    bold: {
                        bp: {
                            xs: tokens.SYS_TYPOGRAPHY_DISPLAY_ORDER1_BOLD_BP_XS,
                            sm: tokens.SYS_TYPOGRAPHY_DISPLAY_ORDER1_BOLD_BP_SM,
                            md: tokens.SYS_TYPOGRAPHY_DISPLAY_ORDER1_BOLD_BP_MD,
                            lg: tokens.SYS_TYPOGRAPHY_DISPLAY_ORDER1_BOLD_BP_LG,
                            xl: tokens.SYS_TYPOGRAPHY_DISPLAY_ORDER1_BOLD_BP_XL,
                            xxl: tokens.SYS_TYPOGRAPHY_DISPLAY_ORDER1_BOLD_BP2_XL
                        }
                    }
                },
                2: {
                    normal: {
                        bp: {
                            xs: tokens.SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_XS,
                            sm: tokens.SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_SM,
                            md: tokens.SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_MD,
                            lg: tokens.SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_LG,
                            xl: tokens.SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_XL,
                            xxl: tokens.SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP2_XL
                        }
                    },
                    bold: {
                        bp: {
                            xs: tokens.SYS_TYPOGRAPHY_DISPLAY_ORDER2_BOLD_BP_XS,
                            sm: tokens.SYS_TYPOGRAPHY_DISPLAY_ORDER2_BOLD_BP_SM,
                            md: tokens.SYS_TYPOGRAPHY_DISPLAY_ORDER2_BOLD_BP_MD,
                            lg: tokens.SYS_TYPOGRAPHY_DISPLAY_ORDER2_BOLD_BP_LG,
                            xl: tokens.SYS_TYPOGRAPHY_DISPLAY_ORDER2_BOLD_BP_XL,
                            xxl: tokens.SYS_TYPOGRAPHY_DISPLAY_ORDER2_BOLD_BP2_XL
                        }
                    }
                }
            }
        },
        headline: {
            order: {
                1: {
                    normal: {
                        bp: {
                            xs: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_XS,
                            sm: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_SM,
                            md: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_MD,
                            lg: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_LG,
                            xl: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_XL,
                            xxl: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP2_XL
                        }
                    },
                    bold: {
                        bp: {
                            xs: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_XS,
                            sm: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_SM,
                            md: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_MD,
                            lg: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_LG,
                            xl: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_XL,
                            xxl: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP2_XL
                        }
                    }
                },
                2: {
                    normal: {
                        bp: {
                            xs: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_XS,
                            sm: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_SM,
                            md: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_MD,
                            lg: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_LG,
                            xl: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_XL,
                            xxl: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP2_XL
                        }
                    },
                    bold: {
                        bp: {
                            xs: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_XS,
                            sm: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_SM,
                            md: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_MD,
                            lg: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_LG,
                            xl: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_XL,
                            xxl: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP2_XL
                        }
                    }
                },
                3: {
                    normal: {
                        bp: {
                            xs: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_XS,
                            sm: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_SM,
                            md: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_MD,
                            lg: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_LG,
                            xl: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_XL,
                            xxl: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP2_XL
                        }
                    },
                    bold: {
                        bp: {
                            xs: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_XS,
                            sm: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_SM,
                            md: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_MD,
                            lg: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_LG,
                            xl: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_XL,
                            xxl: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP2_XL
                        }
                    }
                },
                4: {
                    normal: {
                        bp: {
                            xs: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_XS,
                            sm: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_SM,
                            md: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_MD,
                            lg: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_LG,
                            xl: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_XL,
                            xxl: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP2_XL
                        }
                    },
                    bold: {
                        bp: {
                            xs: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_XS,
                            sm: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_SM,
                            md: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_MD,
                            lg: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_LG,
                            xl: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_XL,
                            xxl: tokens.SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP2_XL
                        }
                    }
                }
            }
        },
        copy: {
            order: {
                1: {
                    normal: tokens.SYS_TYPOGRAPHY_COPY_ORDER1_NORMAL,
                    short: tokens.SYS_TYPOGRAPHY_COPY_ORDER1_SHORT,
                    bold: tokens.SYS_TYPOGRAPHY_COPY_ORDER1_BOLD
                },
                2: {
                    normal: tokens.SYS_TYPOGRAPHY_COPY_ORDER2_NORMAL,
                    short: tokens.SYS_TYPOGRAPHY_COPY_ORDER2_SHORT,
                    bold: tokens.SYS_TYPOGRAPHY_COPY_ORDER2_BOLD
                },
                3: {
                    normal: tokens.SYS_TYPOGRAPHY_COPY_ORDER3_NORMAL,
                    short: tokens.SYS_TYPOGRAPHY_COPY_ORDER3_SHORT,
                    bold: tokens.SYS_TYPOGRAPHY_COPY_ORDER3_BOLD
                }
            }
        }
    }
};
//# sourceMappingURL=system.js.map